import axios from 'axios'

export const getMarketById = async (id, token) => {
  const url = process.env.GATSBY_API_MARKET_SEARCH
  const headers = { Authorization: `Bearer ${token}` }
  const params = { op: 'byId', id }
  const res = await axios({
    method: 'get',
    url,
    headers,
    params
  })
  return {
    response: res.data.hits.hits[0]._source
  }
}
